import { createSvgIcon } from '@mui/material';

export const CircleIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="6" stroke="#AFC0C9" strokeWidth="4" />
  </svg>,
  'CircleIcon',
);
